import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";

window.$ = window.jQuery = require("jquery");

export default {
    name: "UniversidadesPage",
    data() {
        let ss = new MainService();
        return {
            msg: "UniversidadesPage",
            ss: ss,
            ajax: {
                "url": ss.indexUniversidades(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'u.id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Nombre', name: 'u.Nombre', title: 'Nombre' },
                { data: 'Descripcion', name: 'u.Descripcion', title: 'Descripcion' },
                { data: 'Abreviatura', name: 'u.Abreviatura', title: 'Abreviatura' },
                { data: 'SistemaDescripcion', name: 'SistemaDescripcion', title: 'Sistema' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                }, 
            ],

            universidad:{},
            sistemas: [],
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newUniversidad() {
            this.universidad = {};
            this.$refs['frm-universidad'].show();
        },
     
        editUniversidad(id){
            this.categoria = {};
            this.ss.showUniversidades(id)
            .then((result) => {
              let response = result.data;
              this.universidad = response.data[0];
              this.$refs['frm-universidad'].show();
            })
            .catch(error => {
              console.log(error);
              this.isLoading = false;
            });
        },

        showUniversidad(id) {
            this.categoria = {};
            this.isLoading = true;
            this.ss.showUniversidades(id)
              .then((result) => {
                let response = result.data;
                this.universidad = response.data[0];
                this.$refs['view-universidad'].show();
                this.isLoading = false;
              })
              .catch(error => {
                console.log(error);
                this.isLoading = false;
              });
        },

        cancelShowUniversidad(){
            this.universidad = {};
            this.$refs['view-universidad'].hide();
        },

      
        cancelStoreUniversidad() {
            this.universidad = {};
            this.$refs['frm-universidad'].hide();
        },
        saveUniversidad() {
            this.ss.storeUniversidades(this.universidad).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    this.$refs['frm-universidad'].hide();
                    this.$refs['datatable-Universidad'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },

        getSistemas(){
            this.sistemas = [];
            this.ss.listSistema()
              .then((result) => {
                let response = result.data;
                this.sistemas = response.data;
                console.log(this.sistemas);
              })
              .catch(error => {
                console.log(error);
              });
        },
        
        deleteUniversidad(id) {

            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible.",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.ss.deleteUniversidades({ id: id })  
                        .then((result) => {
                            let response = result.data;
                            console.log(response);
                            this.$bvToast.toast(
                                response.msg, 
                                {
                                    title: 'Correcto',
                                    variant: 'success',
                                    autoHideDelay: 5000
                                }
                            )
                            this.$refs['datatable-Universidad'].reload();
                        })
                        .catch(error => {
                            console.log(error);
                        })
                } else {
                    // No hacer nada si el usuario cancela la eliminación
                }
            });
        },
        
        
        draw() {
            window.$('.btn-datatable-Universidad').on('click', (evt) => {
                const buttonId = window.$(evt.target).closest('button').attr('id'); 
                
                if (buttonId.includes('details_')) {
                    const id = buttonId.replace('details_', ''); 
                    this.showUniversidad(id);
                } 
                else if (buttonId.includes('edit_')) {
                    const id = buttonId.replace('edit_', ''); 
                    this.editUniversidad(id);
                } 
                else if (buttonId.includes('delete_')) {
                    const id = buttonId.replace('delete_', ''); 
                    this.deleteUniversidad(id);
                }
            });
        }
    },
    components: {
        dataTable,
     
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            this.auth = persona;
            this.getSistemas();
        }
    }
};
